'use strict'

import $ from 'jquery'

export default class PartnersGrid {
  constructor($el) {
    this.$el = $($el)
    this.setupFiltering()
    // this.setupPagination()
  }

  refreshGrid(paged = 1) {
    $.ajax({
      url: openSystemsJs.ajaxUrl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'get_partners_grid',
        paged: paged,
        base: this.$el.data('base'),
        partnerType: this.$filter.find(':selected').val()
      },
      success: (result) => {
        console.log("result: ", result)
        const $grid = this.$el.find('.partners-grid-container')
        $grid.html(result.grid)
        const $promo_card = this.$el.find('.card-partner-promo')
        $promo_card.find('h3').html($grid.data('promo-title'))
        $promo_card.find('p').html($grid.data('promo-body'))
        $promo_card.find('a').attr('href', $grid.data('promo-cta-url')).attr('target', $grid.data('promo-cta-target')).html($grid.data('promo-cta-title'))
        // this.setupPagination()
      },
      failure: function(err) {
        console.log("Err! ", err)
      }
    })
  }

  setupFiltering() {
    this.$filter = this.$el.find('select')
    this.$filter.on('change', (e) => {
      this.refreshGrid()
    })
  }

  // Pagination disabled since correct SEO linking isn't working; loading all partners instead.
  setupPagination() {
    const $pagination = this.$el.find('.partners-grid-pagination')
    $pagination.find('a').on('click', (e) => {
      e.preventDefault()
      const paged = $(e.currentTarget).text()
      this.refreshGrid(paged)
      // const url = $(e.currentTarget).attr('href')
      // history.pushState({}, "", url)
    })
  }
}